import { CoverPending } from './CoverPending';
import React from 'react';
import { templateLibrary } from '../data/resources';
import { templateSamples } from '../data/pendingContent';
import { siteConfig } from '../data/siteConfig';
export function TemplateLibrary() {
  return <section aria-labelledby="library-title" className="on-dark bg-plum text-cream px-5 sm:px-8 py-16 sm:py-24" data-id="element-197" data-mp="1cjnie0y1ftca">
      <div className="max-w-6xl mx-auto" data-id="element-198" data-mp="1hfm8pu2xflfc">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-center" data-id="element-199" data-mp="juzs1qyfmdrv">
          <div className="lg:col-span-6" data-id="element-200" data-mp="ot1hquqd5bcb">
            <div className="rounded-[2rem] overflow-hidden aspect-square ring-1 ring-butter/50" data-id="element-201" data-mp="ott3ldu5rupe">
              {templateLibrary.image ? <img src={templateLibrary.image} alt={templateLibrary.imageAlt} loading="lazy" decoding="async" className="h-full w-full object-cover" data-id="element-202" data-mp="tqb76adr5n05" /> : <CoverPending title={templateLibrary.name} data-id="element-203" data-mp="148lsy9qr3hp" />}
            </div>
          </div>

          <div className="lg:col-span-6" data-id="element-204" data-mp="62jqyvp3cptl">
            <p className="font-serif text-lg font-semibold text-berry-light" data-id="element-205" data-mp="618p51f7hs54">De sjablonenverzameling</p>
            <h2 id="library-title" className="mt-4 font-serif text-3xl sm:text-[2.6rem] leading-tight font-semibold" data-id="element-206" data-mp="2q5x6wytflhmb">
              {templateLibrary.name}
            </h2>
            <div className="mt-5 h-px w-16 bg-butter" aria-hidden="true" data-id="element-207" data-mp="2gflt8kjy3u28" />
            <p className="mt-5 text-base sm:text-lg leading-relaxed text-cream/85 max-w-lg" data-id="element-208" data-mp="2bhu05n7ke1wg">
              {templateLibrary.description}
            </p>

            <dl className="mt-9 grid sm:grid-cols-2 gap-px rounded-2xl overflow-hidden bg-cream/15" data-id="element-209" data-mp="27ha5qredlce0">
              <div className="bg-plum p-5" data-id="element-210" data-mp="22fkuban8qwpe">
                <dt className="font-serif text-lg font-semibold" data-id="element-211" data-mp="1xh9iwvhase52">De handleidingen</dt>
                <dd className="mt-1 text-sm leading-relaxed text-cream/80" data-id="element-212" data-mp="1sipyx0m9lcfc">
                  Helpen je met de techniek, de materialen en het afwerken.
                </dd>
              </div>
              <div className="bg-plum p-5" data-id="element-213" data-mp="3mwpsgbz4w1vh">
                <dt className="font-serif text-lg font-semibold" data-id="element-214" data-mp="3mxsiyisjo2av">De sjablonen</dt>
                <dd className="mt-1 text-sm leading-relaxed text-cream/80" data-id="element-215" data-mp="1l7a4xr86wgmd">
                  Geven je vormen om te volgen terwijl je punnikt.
                </dd>
              </div>
            </dl>

            <p className="mt-6 text-sm text-cream/80" data-id="element-216" data-mp="1ba5fnij1s51c">
              Onderdeel van het pakket Punniken met Liefde.
            </p>

            <a href="#pakket" className="mt-9 inline-flex w-full sm:w-auto justify-center text-center whitespace-normal rounded-full bg-cream px-6 sm:px-8 py-4 text-base font-semibold text-plum hover:bg-blush transition-colors duration-200" data-id="element-217" data-mp="1g907f9yzt3xl">
              Bekijk het hele pakket — {siteConfig.price}
            </a>
          </div>
        </div>

        {templateSamples.length > 0 && <ul className="mt-14 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4" data-id="element-218" data-mp="1yxx3njdya6ig">
            {templateSamples.map(t => <li key={t.src} className="aspect-[3/4] rounded-xl overflow-hidden bg-cream" data-id="element-219" data-mp="jhety1yzpyqc">
                <img src={t.src} alt={t.alt} loading="lazy" decoding="async" className="w-full h-full object-cover" data-id="element-220" data-mp="nkuq6x75dx2i" />
              </li>)}
          </ul>}
      </div>
    </section>;
}